import React from 'react';
import { NavLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  selected: {
    '&:after': {
      position: 'absolute',
      content: '""',
      height: '5px',
      backgroundColor: theme.palette.primary.main,
      left: '0',
      bottom: '-11px',
      width: '100%',
    },
  },
  selectedPff: {
    '&:after': {
      position: 'absolute',
      content: '""',
      height: '5px',
      backgroundColor: '#e37a00',
      left: '0',
      bottom: '-11px',
      width: '100%',
    },
  },
}));

function MenuItem({
  exact,
  to,
  openCloseCallback = () => {},
  labelLink,
  target = '_self',
  isPff,
}) {
  const classes = useStyles();
  return (
    <li>
      <NavLink
        exact={exact}
        target={target}
        to={to}
        activeClassName={!isPff ? classes.selected : classes.selectedPff}
        onMouseEnter={() => {
          openCloseCallback(true);
        }}
        onClick={() => {
          openCloseCallback(false);
        }}
        onMouseLeave={() => {
          openCloseCallback(false);
        }}
      >
        {labelLink}
      </NavLink>
    </li>
  );
}

MenuItem.propTypes = {
  labelLink: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  openCloseCallback: PropTypes.func,
  exact: PropTypes.bool,
};

export default MenuItem;
